import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  border: none;\n  background-color: transparent;\n  cursor: ", ";\n  outline: none;\n  margin: 0;\n  padding: 0;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  flex-shrink: 0;\n  flex-grow: 0;\n  ", "\n  & > * {\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ICON_LARGE_SIZE, ICON_SIZE, ICON_SMALL_SIZE } from '../constants';
import IconDefault from '../SvgIcon/IconDefault';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY } from '../colors';
import { useDeviceType } from '../hooks';
import { isDefined } from '../helpers/defined';
import { absoluteCenteredStyle } from '../tokens/centered';
import { combineByBreakpoints } from '../helpers/media-combine';
import { buttonIconsColorKeys, buttonIconsColorMixin } from './style/icons-color';
import { buttonTransitionStyle } from './style/transition';
import { userSelectNoneStyle } from '../tokens/user-select';
import { appearanceNoneStyle } from '../tokens/appearance';
import { baseHighlightStyle } from '../tokens/highlight';
import { setNoFocus } from '../helpers/events-focus';
import { withOmitProps } from '../helpers/elements';
import { activePressedStyle } from '../tokens/pressed';
import { size } from '../style/size';
var StyledClickableArea = styled.div(_templateObject(), absoluteCenteredStyle, function (_ref) {
  var $size = _ref.$size;
  return isDefined($size) ? size($size) : '';
});
var ButtonAsIcon = styled.button.withConfig(withOmitProps([].concat(buttonIconsColorKeys, ['hasTouch', 'inactive', 'noAnimate', 'withSuffix', 'withPrefix', 'vertical'])))(_templateObject2(), function (_ref2) {
  var disabled = _ref2.disabled,
      inactive = _ref2.inactive;
  return disabled || inactive ? 'default' : 'pointer';
}, buttonTransitionStyle, baseHighlightStyle, userSelectNoneStyle, appearanceNoneStyle, function (_ref3) {
  var inactive = _ref3.inactive,
      disabled = _ref3.disabled,
      $noTransform = _ref3.$noTransform;
  return !inactive && !disabled && !$noTransform && activePressedStyle;
}, buttonIconsColorMixin, function (_ref4) {
  var $size = _ref4.$size;
  return isDefined($size) ? size($size) : '';
}, absoluteCenteredStyle);
var IconButton = /*#__PURE__*/React.forwardRef(function (_ref5, forwardedRef) {
  var _ref8;

  var as = _ref5.as,
      forwardedAs = _ref5.forwardedAs,
      _ref5$disabled = _ref5.disabled,
      disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
      _ref5$inactive = _ref5.inactive,
      inactive = _ref5$inactive === void 0 ? false : _ref5$inactive,
      _ref5$asDiv = _ref5.asDiv,
      asDiv = _ref5$asDiv === void 0 ? false : _ref5$asDiv,
      _ref5$asSpan = _ref5.asSpan,
      asSpan = _ref5$asSpan === void 0 ? false : _ref5$asSpan,
      _ref5$hasArrow = _ref5.hasArrow,
      hasArrow = _ref5$hasArrow === void 0 ? false : _ref5$hasArrow,
      _ref5$hasClose = _ref5.hasClose,
      hasClose = _ref5$hasClose === void 0 ? false : _ref5$hasClose,
      _ref5$noIcon = _ref5.noIcon,
      noIcon = _ref5$noIcon === void 0 ? false : _ref5$noIcon,
      _ref5$iconComponent = _ref5.iconComponent,
      IconComponent = _ref5$iconComponent === void 0 ? IconDefault : _ref5$iconComponent,
      icon = _ref5.icon,
      iconSize = _ref5.iconSize,
      _ref5$iconColor = _ref5.iconColor,
      iconColor = _ref5$iconColor === void 0 ? ELEMENT_GRAY : _ref5$iconColor,
      _ref5$iconColorHover = _ref5.iconColorHover,
      iconColorHover = _ref5$iconColorHover === void 0 ? ADVENTURE_GREEN : _ref5$iconColorHover,
      _ref5$iconColorActive = _ref5.iconColorActive,
      iconColorActive = _ref5$iconColorActive === void 0 ? ADVENTURE_GREEN_FOCUSED : _ref5$iconColorActive,
      _ref5$iconColorFocus = _ref5.iconColorFocus,
      iconColorFocus = _ref5$iconColorFocus === void 0 ? ADVENTURE_GREEN : _ref5$iconColorFocus,
      _ref5$iconColorDisabl = _ref5.iconColorDisabled,
      iconColorDisabled = _ref5$iconColorDisabl === void 0 ? ELEMENT_GRAY : _ref5$iconColorDisabl,
      _ref5$arrow = _ref5.arrow,
      arrow = _ref5$arrow === void 0 ? 'right' : _ref5$arrow,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? ICON_SIZE : _ref5$size,
      outerSize = _ref5.outerSize,
      _ref5$sizeVariant = _ref5.sizeVariant,
      sizeVariant = _ref5$sizeVariant === void 0 ? 'medium' : _ref5$sizeVariant,
      _ref5$noFocus = _ref5.noFocus,
      noFocus = _ref5$noFocus === void 0 ? false : _ref5$noFocus,
      _ref5$noTransform = _ref5.noTransform,
      noTransform = _ref5$noTransform === void 0 ? false : _ref5$noTransform,
      props = _objectWithoutPropertiesLoose(_ref5, ["as", "forwardedAs", "disabled", "inactive", "asDiv", "asSpan", "hasArrow", "hasClose", "noIcon", "iconComponent", "icon", "iconSize", "iconColor", "iconColorHover", "iconColorActive", "iconColorFocus", "iconColorDisabled", "arrow", "size", "outerSize", "sizeVariant", "noFocus", "noTransform"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var iconComponentSize = useMemo(function () {
    return (
      /* prettier-ignore */
      iconSize || (typeof sizeVariant === 'string' ? hasArrow ? sizeVariant === 'tiny' ? ICON_SIZE : ICON_LARGE_SIZE : sizeVariant === 'tiny' ? ICON_SMALL_SIZE : ICON_SIZE : hasArrow ? combineByBreakpoints([sizeVariant, ICON_SIZE, ICON_LARGE_SIZE], function (_ref6) {
        var sizeVariant = _ref6[0],
            sizeTiny = _ref6[1],
            sizeDefault = _ref6[2];
        return sizeVariant === 'tiny' ? sizeTiny : sizeDefault;
      }) : combineByBreakpoints([sizeVariant, ICON_SMALL_SIZE, ICON_SIZE], function (_ref7) {
        var sizeVariant = _ref7[0],
            sizeTiny = _ref7[1],
            sizeDefault = _ref7[2];
        return sizeVariant === 'tiny' ? sizeTiny : sizeDefault;
      }))
    );
  }, [iconSize, hasArrow, sizeVariant]);
  return /*#__PURE__*/React.createElement(ButtonAsIcon, _extends({
    as: (_ref8 = forwardedAs != null ? forwardedAs : as) != null ? _ref8 : props.href ? 'a' : asDiv ? 'div' : asSpan ? 'span' : undefined,
    ref: forwardedRef,
    onTouchStart: function onTouchStart() {},
    disabled: disabled,
    inactive: inactive,
    iconColor: iconColor,
    hoverIconColor: iconColorHover,
    activeIconColor: iconColorActive,
    focusIconColor: iconColorFocus,
    disabledIconColor: iconColorDisabled,
    $noTransform: noTransform,
    $hasTouch: hasTouchScreen,
    $size: size
  }, props, setNoFocus(props, noFocus)), outerSize && /*#__PURE__*/React.createElement(StyledClickableArea, {
    $size: outerSize
  }), !noIcon && /*#__PURE__*/React.createElement(IconComponent, {
    disabled: disabled,
    hasArrow: hasArrow,
    hasClose: hasClose,
    arrow: arrow,
    size: iconComponentSize,
    icon: icon,
    color: null,
    colorHover: null
  }));
});
export default IconButton;